import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className, once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-8% 0px" }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const LineReveal = ({ lines, className, lineClassName, delay = 0, stagger = 0.12, inView = false, as: Tag = "h1", ...rest }) => {
  const anim = inView
    ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } }
    : { animate: "show" };
  return (
    <Tag className={className} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line block">
          <motion.span
            className={`block ${lineClassName || ""}`}
            initial="hidden"
            {...anim}
            variants={{ hidden: { y: "112%", rotate: 1.5 }, show: { y: 0, rotate: 0 } }}
            transition={{ duration: 1.15, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Stagger = ({ children, className, delay = 0, ...rest }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8% 0px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.1, delayChildren: delay } } }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className, y = 32, ...rest }) => (
  <motion.div
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } } }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
